import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('customer-area');
